module.exports = __webpack_public_path__ + "img/splash_demo.c7d13187.jpg";